import React from 'react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock, CtaGuaranteeRow } from './CtaBlock';
import { valueStack } from '../data/content';
export function ValueStack() {
  return <section id="offerta" className="bg-navy-900 py-14 sm:py-20" data-id="element-296" data-mp="1q8uvg5weylq7">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-297" data-mp="1qaphxonc2lwe">
        <SectionHeading eyebrow="L’offerta completa" tone="dark" title="Il tuo sistema clinico TRT completo" subtitle="Tutto ciò di cui hai bisogno per costruire un processo decisionale TRT più organizzato." data-id="element-298" data-mp="1uapxjcm65351" />

        <div className="mt-10 overflow-hidden rounded-2xl bg-white" data-id="element-299" data-mp="297gvrik3w8t2">
          <div className="flex items-center justify-between border-b border-navy-900/10 bg-navy-50 px-4 py-3 sm:px-5" data-id="element-300" data-mp="2954hpghgyila">
            <span className="text-[10px] font-black uppercase tracking-[0.16em] text-navy-900/50" data-id="element-301" data-mp="30yeq0r24g1gn">
              Incluso
            </span>
            <span className="text-[10px] font-black uppercase tracking-[0.16em] text-navy-900/50" data-id="element-302" data-mp="35q50qy4z0r8l">
              Valore
            </span>
          </div>

          <ul data-id="element-303" data-mp="1oga3uc5giy4k">
            {valueStack.map(row => <li key={row.name} className="flex items-start justify-between gap-3 border-b border-navy-900/[0.07] px-4 py-3.5 sm:px-5" data-id="element-304" data-mp="1ohuwfw87o6zs">
                <span className="text-[14px] font-semibold leading-snug text-navy-900" data-id="element-305" data-mp="1ydeo26fqsjiq">
                  {row.name}
                </span>
                <span className="shrink-0 text-[14px] font-bold text-navy-900/45 line-through" data-id="element-306" data-mp="2c7xj1wtcwkr0">
                  {row.value}
                </span>
              </li>)}
          </ul>

          <div className="flex items-center justify-between gap-3 bg-navy-50 px-4 py-4 sm:px-5" data-id="element-307" data-mp="2m1xx4o6m90bv">
            <span className="text-[12px] font-black uppercase tracking-[0.12em] text-navy-900" data-id="element-308" data-mp="2h2urp2mq4s3d">
              Valore totale
            </span>
            <span className="text-lg font-black text-navy-900/50 line-through" data-id="element-309" data-mp="mrg5gvsx9asd">
              546 EUR
            </span>
          </div>

          <div className="bg-gold-500 px-4 py-6 text-center sm:px-5" data-id="element-310" data-mp="2muqpqlp1tvrz">
            <p className="text-[11px] font-black uppercase tracking-[0.18em] text-navy-950/70" data-id="element-311" data-mp="2rrh6zcclaxez">
              Ma oggi paghi solo
            </p>
            <p className="mt-1 text-6xl font-black leading-none text-navy-950 sm:text-7xl" data-id="element-312" data-mp="2vvyof4vh8yml">
              19<span className="ml-1 text-2xl align-top sm:text-3xl" data-id="element-313" data-mp="30quehzh5lbx2">EUR</span>
            </p>
            <p className="mt-3 text-[11px] font-bold uppercase leading-snug tracking-[0.1em] text-navy-950/70" data-id="element-314" data-mp="35rrwoc25y5yk">
              Pagamento unico · Accesso digitale immediato · Accesso a vita
            </p>
            <p className="mt-1.5 text-[11px] font-semibold text-navy-950/60" data-id="element-315" data-mp="3fjxyedi7w1qy">
              Il cambio di valuta è automatico secondo il tuo paese
            </p>
          </div>
        </div>

        <div className="mt-8 flex justify-center" data-id="element-316" data-mp="3okcmfkmkfuy5">
          <CtaBlock tone="dark" label="Ottieni il Sistema Maestro della TRT™" note="Prezzo promozionale valido solo per i posti rimanenti" showScarcity data-id="element-317" data-mp="3th31q5qjqmii" />
        </div>
        <div className="mt-5" data-id="element-318" data-mp="2gamxlmqgj54">
          <CtaGuaranteeRow tone="dark" data-id="element-319" data-mp="2j59bipb4e16" />
        </div>
      </div>
    </section>;
}